// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:28:39Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci se známými subjekty. <p> Pro založení subjektu, který má v roli nastavenou vazbu na registry je nutné nejdříve zavolat metodu {@link #overSubjekt(Subjekt, String)}, vzít její výsledek (případně vybrat uživatelem jeden z více vrácených) a ten předat do metody {@link #zalozSubjekt(Subjekt, Integer, Integer, String, boolean)}, která může vrátit (v případě dohledání více subjektů v lokálních datech) další seznam, ze kterého je třeba vybrat a zavolat metodu s daným výběrem. </p> <p> Pokud se subjekt ověřuje do registrů, dostane při ověření id ověření, které je nutné použít pro založení subjektu. </p> Generated from cz.marbes.api.subjekt.SubjektService.
 */
export default class SubjektApi {
    /**
     * Zaevidování nového subjektu v dané roli, založení se nemusí povést v případě dohledání duplicitních subjektů v lokální databázi. Metoda se pokusí se založit předaný subjekt. Pokud je předáno id ověření (získáné z metody {@link #overSubjekt(Subjekt, String)}), jsou pro založení použita identifikační (jméno, příjmení, název firmy atp.) data z vazby na základní registry. Neidentifikační údaje jsou použity z předaného subjektu v parametru metody. <ul> <li>Pokud v lokálních datech neexistuje žádný odpovídající subjekt, založí se nový a ten se vrátí.</li> <li>Pokud je v lokální databázi nalezen jeden subjekt (dohledaný podle údajů z předaného subjektu dle daných kriterií), je tento subjekt aktualizován a vrácen.</li> <li>Pokud je v lokální databázi nalezeno více subjektů, není nic založeno a vrátí se seznam dohledaných subjektů.</li> , po vybrání jednoho <ul> <li>Pokud je v {@link SubjektZalozeniResult} vráceno {@link TypZalozeni#VICE_US} nebo {@link TypZalozeni#VICE_US_ZR}, musí se vybrat jeden z vrácených ztotožněných subjektů a tato metoda se zavolá znovu s id vybraného ztotožněného subjektu.</li> <li>Pokud je v {@link SubjektZalozeniResult} vráceno {@link TypZalozeni#CASTECNA_SHODA}, může se metoda volat s vybraným stotožněným subjektem, nebo s parametrem force, kdy se jedná o nové založení.</li> </ul> </ul>
     *
     * @param subjektZalozeniParam 
     * @return výsledek založení nebo dohledání
     */
    static zalozSubjekt(subjektZalozeniParam : SubjektZalozeniParam) : Promise<SubjektZalozeniResult> {
        const uri = serverContextPath + `/api/subjekt`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateSubjektZalozeniParam_247D56(subjektZalozeniParam), headers));
    }

    /**
     * Načtení všech zástupců daného subjektu.
     *
     * @return seznam zástupců nebo prázdný seznam
     */
    static getZastupci() : Promise<Zastupce[]> {
        const uri = serverContextPath + `/api/subjekt/{subjektId}/zastupce`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoření občanství ke konkrétnímu subjektu.
     *
     * @param subjektId id subjektu
     * @param obcanstvi občanství
     * @return vytvořený občanství
     */
    static createObcanstvi(subjektId : number, obcanstvi : Obcanstvi) : Promise<Obcanstvi> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/obcanstvi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateObcanstvi_B99D00(obcanstvi), headers));
    }

    /**
     * Smazání zástupce. Maže vazbu na zastupující subjekt, nikoli vlastní subjekt, maže tedy vazbu mezi zastupovaným a zastupujícím subjektem. Pokud je nastaven tento zástupce jako výchozí u subjektu, je odebrán a subjekt nemá výchozího zástupce.
     *
     * @param subjektId id subjektu pro mazání nemá význam.
     * @param zastupceId 
     */
    static deleteZastupce(subjektId : number, zastupceId : number) {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/zastupce/${zastupceId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Najde subjekty podle vzoru. Interně využívá stejný algoritmus ztotožnění jako metoda {@link #zalozSubjekt(SubjektZalozeniParam)}.
     *
     * @param subjekt vzorový subjekt
     * @param kodRole kód role
     * @param minShoda minimální potřebná shoda pro navrácení subjektu
     * @return nalezené subjekty
     */
    static findSubjektyByVzor(subjekt : Subjekt, kodRole : string, minShoda : ShodaSubjektu) : Promise<SubjektZtotozneniResult[]> {
        const uri = serverContextPath + `/api/subjekty/vzor`;
        const headers = undefined;
        const params = { kodRole, minShoda };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateSubjekt_62E626(subjekt), headers));
    }

    /**
     * Aktualizace existujícího subjektu. Při aktualizaci lze nastavit vazbu na ZR, pokud je předáno id ověření, je rovnou ztotožněn na registry, pokud předáno není, je uložen s vazbou na registry, ale není ztotožněn. Pokud subjekt měl vazbu na zr a je předána hodnota false, tak se nejdříve vazba na zr zruší.
     *
     * @param subjektId id subjektu
     * @param subjektFull nové informace o subjektu
     * @param overeniId id ověření dohledaného subjektu v registrech nebo null, pokud není známo - používá se pro napojení subjektu na dohledaný subjekt z registrů
     * @param forced 
     * @return výsledek aktualizace, v případě dohledání duplicit se nemusí jednat o aktualizaci, ale jen vrácení seznam duplicitních záznamů
     */
    static updateSubjektFull(subjektId : number, subjektFull : SubjektFull, overeniId : number, forced : boolean) : Promise<SubjektUpdateResult> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/full`;
        const headers = undefined;
        const params = { overeniId, forced };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateSubjektFull_E17771(subjektFull), headers));
    }

    /**
     * Načtení subjektu dle id.
     *
     * @param subjektId id subjektu
     * @return subjekt
     */
    static getSubjektById(subjektId : number) : Promise<Subjekt> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Založí subjekt do předané/nové role.
     *
     * @return {@link Subjekt} s předanou rolí, nebo vyjímka
     */
    static zalozSubjektDoJineRole() : Promise<Subjekt> {
        const uri = serverContextPath + `/api/subjekt/jinarole`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Provede hledání subjektu v základních registrech nebo Aresu (podle konfigurace na roli). Pokud hledání v registrech není na roli povoleno metoda vyhodí výjimku.
     *
     * @param subjekt šablona pro hledání
     * @param kodRole kód role
     * @param chytreZtotozneni pokud je true, použije se pro ověření chytré dohledání subjektu - nedohledává se podle zadaných údajů, ale podle různých kombinací, to má větší úspěšnost pokud např. některý údaj není správný, např. u FO se hledá nejdříve jen podle dokladu, poté podle ds, poté jméno+příjmení+datum narození, poté ..., pokud je false, tak se hledá podle zadaných údajů a subjekt nemusí být nalezen, pokud je např. špatně doklad, ale jméno, příjmení a datum narození je v pořádku
     * @return seznam nalezených subjektů
     */
    static overSubjekt(subjekt : Subjekt, kodRole : string, chytreZtotozneni : boolean) : Promise<SubjektOvereniResult[]> {
        const uri = serverContextPath + `/api/subjekt/overeni/${kodRole}`;
        const headers = undefined;
        const params = { chytreZtotozneni };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateSubjekt_62E626(subjekt), headers));
    }

    /**
     * Najde subjekty podle zadaných id. Pokud subjekt není podle id nalezen, tak není ani vrácen ve výsledku.
     *
     * @param ids seznam id
     * @return nalezené subjekty nebo prázdný seznam, seznam může být menší než předaný seznam id
     */
    static findSubjektyByIds(ids : number[]) : Promise<Subjekt[]> {
        const uri = serverContextPath + `/api/subjekty/ids`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Smazání občanství u subjektu.
     *
     * @param subjektId id subjektu pro mazani nema vyznam.
     * @param obcanstviId id vazby
     */
    static deleteObcanstvi(subjektId : number, obcanstviId : number) {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/obcanstvi/${obcanstviId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Fulltextové hledání subjektů.
     *
     * @param fulltext fulltext řetězec
     * @param kodRole kód role, pro který se mají subjekty hledat
     * @param typySubjektu seznam typů subjektů, přes které se má vyhledávat, pokud je null nebo je prázdné, hledá se přes všechny známé subjekty (kromě neznámé osoby)
     * @param max maximální počet vrácených záznamů, max. však {@link #FULLTEXT_MAX}
     * @return nalezené subjekty nebo prázdný seznam
     */
    static findSubjekty(fulltext : string, kodRole : string, typySubjektu : EnumSet, max : number) : Promise<Subjekt[]> {
        const uri = serverContextPath + `/api/subjekty`;
        const headers = undefined;
        const params = { fulltext, kodRole, typySubjektu, max };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení všech občanství daného subjektu.
     *
     * @param subjektId id subjektu
     * @return seznam občanství nebo prázdný seznam
     */
    static getObcanstvi(subjektId : number) : Promise<Obcanstvi[]> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/obcanstvi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení subjektu dle id, plná verze objektu.
     *
     * @param subjektId 
     * @return subjekt - plná verze
     */
    static getSubjektFullById(subjektId : number) : Promise<SubjektFull> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/full`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoření zástupce ke konkrétnímu subjektu. Přidání do seznamu možných zástupců subjektu. Nepracuje s nastavením výchozího zástupce u subjektu. Pokud již vazba existuje, nic se nestane a vrátí se existující vazba.
     *
     * @param subjektId id subjektu
     * @param zastupce zástupce
     * @return vytvořený zástupce
     */
    static createZastupce(subjektId : number, zastupce : Zastupce) : Promise<Zastupce> {
        const uri = serverContextPath + `/api/subjekt/${subjektId}/zastupce`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateZastupce_5A781F(zastupce), headers));
    }

    /**
     * Aktualizace existujícího subjektu. Při aktualizaci nelze nastavit vazbu na ZR, na to slouží jiné metody.
     *
     * @param idSubjekt id subjektu
     * @param subjekt nové informace o subjektu
     * @param forced pokud je true, nekontrolují se při aktualizaci duplicity v lokálních datech, standardně se volá s false a až když se vrátí v {@link SubjektUpdateResult} seznam duplicitních, volá se s "požehnáním" uživatele s true
     * @return výsledek aktualizace, v případě dohledání duplicit se nemusí jednat o aktualizaci, ale jen vrácení seznam duplicitních záznamů
     */
    static updateSubjekt(idSubjekt : number, subjekt : Subjekt, forced : boolean) : Promise<SubjektUpdateResult> {
        const uri = serverContextPath + `/api/subjekt/${idSubjekt}/${forced}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateSubjekt_62E626(subjekt), headers));
    }

}